module.exports = __webpack_public_path__ + "static/img/bg22.a634782d.png";